module.exports = __webpack_public_path__ + "img/bg-type02.db752945.png";